

import { jsonServerRestClient, fetchUtils, Admin, Resource } from 'admin-on-rest';
const httpClient = (url, options) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    
    var token = localStorage.getItem('token') 
    options.user={token:token}
    var user = localStorage.getItem('user') || 'none'

    options.headers.set('Authorization', `Bearer ${token}`);
    
    //console.log(token)
    return fetchUtils.fetchJson(url, options);

}


const restClient = jsonServerRestClient('https://api-dev.slika.org.il/api',httpClient);
export default (type, resource, params) => new Promise(resolve => setTimeout(() => resolve(restClient(type, resource, params)), 500));



// WEBPACK FOOTER //
// ./src/restClient.js